import Apple from "../../../assets/images/vegetablesItem/icon2.png";
import Leaf from "../../../assets/images/vegetablesItem/icon1.png";
import Shroom from "../../../assets/images/vegetablesItem/icon3.png";
// import Dot from "./dot.svg";
const titleButtonData = [
  {
    id: 1,
    title: "野菜",
    _id: "野菜",
    logo: Leaf,
  },
  {
    id: 2,
    title: "くだもの",
    _id: "くだもの",
    logo: Apple,
  },
  {
    id: 3,
    title: "きのこ類",
    _id: "きのこ類",
    logo: Shroom,
  },

  {
    id: 4,
    title: "魚貝類",
    _id: "魚貝類",
    logo: false,
  },
  {
    id: 5,
    title: "玉子・乳製品",
    _id: "玉子・乳製品・豆腐・ゆで麺類",
    logo: false,
    //・豆腐・ゆで麺類
  },
  {
    id: 6,
    title: "乾物・穀物・漬け物",
    _id: "乾物・穀物・漬け物",
    logo: false,
  },
  {
    id: 7,
    title: "調味料・その他",
    _id: "調味料・その他",
    logo: false,
  },
];
export default titleButtonData;
